import axios, {AxiosError, InternalAxiosRequestConfig} from "axios";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import { RootStore } from "../store/RootStore";
import { DatasetInfo } from "../store/DatasetStore";
import { DatasetImgInfo } from "../store/DatasetStore";
import { TrainModelParam } from "../model/TrainModelParam";

// official
const SERVER = "https://api.yunmoai.com";
export const LOGIN_SERVER = "https://yunmoai.com/login?";
export const WEB_VERSION_URL = "https://yunmoai.com/train";
export const IMG_PREFIX = "https://assets.hanchaomr.com/YunmoGenAssets";
export const IMG_PREFIX_1 = 'https://assets.hanchaomr.com/'
const ENV = "official";

// in-house
// const SERVER = "https://api.yunmoai.com";
// export const LOGIN_SERVER = "http://192.168.1.100/yijing-login-official/index.html?";
// export const WEB_VERSION_URL = "http://localhost:3000";
// export const IMG_PREFIX = "https://localapi.yunmoai.com/file/yunmoGen";
// export const IMG_PREFIX_1 = 'https://assets.hanchaomr.com/'
// const ENV = "test";

// self
// const SERVER = "https://localapi.yunmoai.com";
// export const LOGIN_SERVER = "http://192.168.1.100/yijing-login-local/index.html?";
// export const WEB_VERSION_URL = "http://192.168.1.100/train";
// export const IMG_PREFIX = "https://localapi.yunmoai.com/file/yunmoGen";
// export const IMG_PREFIX_1 = 'https://assets.hanchaomr.com/'
// const ENV = "test";

// self in-house
// const SERVER = "https://localapi.yunmoai.com";
// export const LOGIN_SERVER = "http://192.168.1.100/yijing-login-local/index.html?";
// export const WEB_VERSION_URL = "http://localhost:3000";
// export const IMG_PREFIX = "https://localapi.yunmoai.com/file/yunmoGen";
// export const IMG_PREFIX_1 = 'https://assets.hanchaomr.com/'
// const ENV = "test";

const getRandom = (width: number) => {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return Array.from({length: width}, (k, i) => {
        const random = Math.floor(Math.random() * chars.length);
        return chars.substring(random, random + 1);
    }).join("");
};

export const encrypt = (data: any): [any, any] => {
    const secretKey = getRandom(16);
    const str = JSON.stringify(data);
    const encryptRes = CryptoJS.AES.encrypt(str, CryptoJS.enc.Utf8.parse(secretKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return [secretKey, encryptRes.toString()];
};

const decrypt = (word: string, keyStr: string): string => {
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypt.toString(CryptoJS.enc.Utf8);
}

const encrypKey = (key: string): string => {
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEZM28XFGWOsNyz/uy2oNmiSn4KMYuC5dxDqjHBdzARtA3/Uu+OlCdFb14Bm0nm2kJUzC029bgAUL0JAPmSRtoalMBfFqVGIdUt4jFW5L3ZHQ/Rx7okPFfXQjefMW2agne7kcK9u10JINFUYKmFmnTaKe6Vp/T7SKZIJr7xC3mywIDAQAB");
    const res = jsencrypt.encrypt(key) as string;
    return res;
};

const axiosInstance = axios.create();
axiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = RootStore.common.getToken();
    if (token.length > 0) {
        config.headers.set("Authorization", token);
    }
    return config;
});

async function getReq(url: string, thenFunc: (res: any) => any) {
    return axiosInstance.get(url)
        .then((res) => {
            if (res.data.code != 200) {
                throw new Error(res.data.msg);
            }
            return thenFunc(res);
        })
        .catch((e: AxiosError) => {
            throw new Error(e.message);
        });
}

async function getReqAuthorized(url: string, token: string, thenFunc: (res: any) => any) {
    return axiosInstance.get(url, {headers: {Authorization: token}})
        .then((res) => {
            if (res.data.code != 200) {
                throw new Error(res.data.msg);
            }
            return thenFunc(res);
        }).catch((e: AxiosError) => {
            throw new Error(e.message);
        });
}

async function postReq(url: string, data: any, thenFunc: (res: any) => any, useEncrypt: boolean = false) {
    const [secretKey, encryptRes] = useEncrypt ? encrypt(data) : ["", data];
    const config = useEncrypt ? {
        headers: {
            "Content-Type": "application/json",
            encrypt: encrypKey(secretKey)
        }
    } : {
        headers: {
            "Content-Type": "application/json"
        }
    };

    return axiosInstance.post(url, useEncrypt ? {data: encryptRes} : data, config)
        .then((res) => {
            if (useEncrypt && !res.data.code) {
                res.data = JSON.parse(decrypt(res.data, secretKey));
            }
            if (res.data.code != 200) {
                throw new Error(res.data.msg);
            }
            return thenFunc(res);
        })
        .catch((e: AxiosError) => {
            throw new Error(e.message);
        });
}

async function deleteReq(url: string, thenFunc: (res: any) => any) {
    return axiosInstance.delete(url)
        .then((res) => {
            if (res.data.code != 200) {
                throw new Error(res.data.msg);
            }
            return thenFunc(res);
        })
        .catch((e: AxiosError) => {
            throw new Error(e.message);
        });
}

export function login(data: any): Promise<any> {
    return postReq(`${SERVER}/yunmo/loginWeb`, data, (res) => {
        return res.data;
    });
}

export function getUserInfo(token: string): Promise<any> {
    return getReqAuthorized(`${SERVER}/yunmo/user/info`, token, (res) => {
        return res.data;
    });
}

export function changeProfile(data: any): Promise<any> {
    return postReq(`${SERVER}/yunmo/user/profile`, data, (res) => res.data);
}

// 上传图片
export function uploadImgToServer(file: File): Promise<string> {
    if(ENV.startsWith("test")){
        return axiosInstance.post("https://api.yunmoai.com/file/upload", {file: file}, {headers: {"Content-Type": "multipart/form-data"}}).then((res) => {
            if (res.data.code != 200) {
                throw new Error(res.data.msg);
            }
            return Promise.resolve(`https://assets.hanchaomr.com${res.data.data.url}`);
        });
    }
    return axiosInstance.post("https://api.yunmoai.com/yunmo/user/uploadPostThumb", {file: file}, {headers: {"Content-Type": "multipart/form-data"}}).then((res) => {
        if (res.data.code != 200) {
            throw new Error(res.data.msg);
        }
        return Promise.resolve(`https://assets.hanchaomr.com/YunmoGenAssets${res.data.data}`);
    });
}

export function sendBindSms(data: any): Promise<any> {
    return postReq(`${SERVER}/auth/smsBindPhone2`, data, res => res.data)
}

export function bindPhone(data: any): Promise<any> {
    return postReq(`${SERVER}/auth/bindPhone`, data, res => res.data)
}

export function getScoreConfig(): Promise<any> {
    return getReq(`${SERVER}/yunmo/open/config`, res => res.data.data);
}

export function getAllPulished(pageNum: number, pageSize: number): Promise<any> {
    return getReq(`${SERVER}/yunmo/post/listPublished?pageNum=${pageNum}&pageSize=${pageSize}`, res => res.data)
}

export function starImg(imgId: string, state: string): Promise<any> {
    return postReq(`${SERVER}/yunmo/post/recommend`, {postId: imgId, stared: state}, (res) => res.data);
}

export function userSign(token: string): Promise<any> {
    return getReqAuthorized(`${SERVER}/yunmo/user/sign`, token, (res) => {
        return res.data;
    });
}

export function updatePswd(data: any): Promise<any> {
    return postReq(`${SERVER}/system/user/profile/updatePwd`, data, res => res.data);
}

export function userLogout(): Promise<any> {
    return postReq(`${SERVER}/yunmo/logout`, {}, res => res.data);
}


export function userLink(): Promise<any> {
    return getReq(`${SERVER}/yunmo/user/shareLink`, res => res.data)
}


export function wyLogin(ticket:string,openid:string){
    return  getReq(`${SERVER}/auth/wylogin?ticket=${ticket}&openid=${openid}`, res => res.data)
}

//用户名/手机号 密码登录
export function loginWeb(data:any){
    return postReq(`${SERVER}/yunmo/loginWeb`, data, res => res.data);
}

//手机号码登录 -- 发送验证码
export function smsLogin(data:any){
    return postReq(`${SERVER}/auth/smsLogin`,data,res=>res.data)
}
//手机号码登录
export function loginPhoneCode(data:any){
    return postReq(`${SERVER}/yunmo/loginPhoneWeb`,data,(res)=>res.data)
}


//微信登录/注册 --- 登录二维码生成
export function createQrCode(){
    return getReq(`${SERVER}/auth/wxFo/qrCode`,res=>res.data)
}
//微信登录/注册 --- 发送微信绑定手机验证码
export function smsBind(data:any){
     return postReq(`${SERVER}/auth/smsBindPhone`,data,res=>res.data)
}

//微信登录/注册 --- 微信绑定手机号
export function wxBindInfo(data:any,wxOpenId:string,qrScene:string){
    return postReq(`${SERVER}/auth/wxFo/complete?wxOpenID=${wxOpenId}&qrScene=${qrScene}`,data,(res)=>res.data)
}

//微信登录/注册  --- 检测二维码扫描状态
export function wxLogin(ticket:string){
    return getReq(`${SERVER}/auth/wxFo/login?ticket=${ticket}`,res => res.data)
}


//发送注册验证码
export function smsRegister(data:any){
    return postReq(`${SERVER}/auth/smsRegister`,data,res=>res.data)
}

//用户注册
export function regPhone(data:any){
    return postReq(`${SERVER}/auth/regPhone`,data,(res)=>res.data)
}

// 忘记密码 -- 发送验证码
export function smsResetPwd(data:any){
    return postReq(`${SERVER}/auth/smsRetrieve`,data,res=>res.data)
}

// 忘记密码 -- 验证手机验证码
export function checkPhone(data:any){
    return postReq(`${SERVER}/auth/checkPhone`,data,res=>res.data)
}

// 忘记密码 -- 重置密码

export function resetPwd(data:any){
    return postReq(`${SERVER}/auth/pwdRerieve`,data,res=>res.data)
}

// 文生3d preview
export function txtTo3dPreview(data: any){
    return postReq(`${SERVER}/yunmo/user/3d/textTo3DPreview`, data, res => res.data.data);
}

// 图生3d preview
export function imgTo3dPreview(data: any){
    return postReq(`${SERVER}/yunmo//user/3d/imageTo3D`, data, res => res.data.data);
}

// 模型细化
export function refineModel(data: any){
    return postReq(`${SERVER}/yunmo/user/3d/textTo3DRefine`, data, res => res.data.data);
}

// 反向获取提示词
export function fetchPrompt(img: string): Promise<string>{
    return postReq(`${SERVER}/yunmo/user/describeImage`, {base64Image: img.substring(img.indexOf(",") + 1)}, res => res.data.data.replaceAll("\\", "").replaceAll("\"", ""));
}

// 获取数据集列表
export function getDatasetList(): Promise<DatasetInfo[]>{
    return getReq(`${SERVER}/yunmo/user/dataset`, res => {
        return res.data.rows.map(DatasetInfo.createFromJson)
    });
}

// 创建数据集
export function newDataset(title: string, description: string): Promise<DatasetInfo>{
    return postReq(`${SERVER}/yunmo/user/dataset`, {name: title, description: description}, res => DatasetInfo.createFromJson(res.data.data));
}

// 删除数据集
export function delDataset(id: string){
    return postReq(`${SERVER}/yunmo/user/dataset/del`, {id: id}, res => res);
}

// 删除数据集资源
export function delDatasetImgs(datasetId: string, imgIds: string[]){
    return postReq(`${SERVER}/yunmo/user/dataset/${datasetId}/del`, {ids: imgIds}, res => res);
}

// 新增数据集资源
export function addDatasetImg(datasetId: string, imgUrl: string): Promise<DatasetImgInfo>{
    return postReq(`${SERVER}/yunmo/user/dataset/${datasetId}/add`, {file: imgUrl}, res => DatasetImgInfo.createFromJson(res.data.data));
}

// 更新数据集资源
export function updateDatasetImg(datasetId: string, imgId: string, url: string, text: string): Promise<any>{
    return postReq(`${SERVER}/yunmo/user/dataset/${datasetId}/upd`, {id: imgId, file: url, captions: text}, res => res);
}

// 获取数据集资源
export function fetchDatasetImgs(datasetId: string, pageIndex?: number, pageSize?: number): Promise<{total: number, imgs: DatasetImgInfo[]}>{
    return getReq(`${SERVER}/yunmo/user/dataset/${datasetId}/list?pageNum=${pageIndex ?? 1}&pageSize=${pageSize ?? 100}`, res => {
        return DatasetImgInfo.createArrayFromJson(res.data.rows).then(imgs => Promise.resolve({total: res.data.total, imgs: imgs}));
    });
}

// 开始训练任务
export function startTrainModel(param: TrainModelParam): Promise<string>{
    return postReq(`${SERVER}/yunmo/user/training`, param, res => res.data.data);
}

// 获取任务进度
export async function fetchTaskProgress(taskId: string): Promise<any> {
    return postReq(`${SERVER}/yunmo/user/taskProgress/${taskId}`, {}, (res) => {
        return res.data.data;
    });
}

// 获取任务结果
export function getTaskInfo(taskId: string): Promise<any> {
    return postReq(`${SERVER}/yunmo/user/task/${taskId}`, {}, (res) => {
        return res.data.data;
    });
}

// 获取任务历史
export function getUserHistory(type: number): Promise<any> {
    return getReq(`${SERVER}/yunmo/user/history?&type=${type}`, res => res.data.data);
}

// 删除任务
export function deleteTask(taskId: string): Promise<any> {
    return postReq(`${SERVER}/yunmo/user/taskDel/${taskId}`, {}, (res) => res.data);
}